// extracted by mini-css-extract-plugin
export default {"contentContainer":"content-style_contentContainer__Lu2PZ"};